<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication">To Ellen Datlow, with love and gratitude for 27 years of friendship, acute editorial insight, and doll heads</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled11.vue?02718576